<template>
  <div class="questions">
    <div ref="question" v-for="(item, index) in questionList" :key="index" class="question">
      <div class="question-title" @click.stop="handleIsFold(item)">
        <span>
          <i v-if="item.tier < 4" :class="item.isFold ? 'el-icon-caret-right' : 'el-icon-caret-bottom'"></i>
          <span v-if="dataTier">{{ dataTier }}. </span> {{ index + 1 }}.
        </span>
        {{ item.name }}（{{ item.score }}分）
        <!-- pc端样式 -->
        <div class="editGrop">
          <i @click.stop="handledialog(item.tier, item)" class="el-icon-edit"></i>
          <i @click.stop="handledialog(item.tier + 1, item, true)" class="el-icon-circle-plus-outline"></i>
          <img @click.stop="handleAddRule(1, item)" src="../../../assets/img/riLine.png" alt="" />
          <i @click.stop="handleAddQuestion(3, item)" class="el-icon-delete"></i>
        </div>
        <!-- 移动端样式 -->
        <el-popover popper-class="popoClass" :append-to-body="true" class="dropdownGrop" trigger="click" placement="bottom-end">
          <div @click.stop="handledialog(item.tier, item)" class="popoBox"><i class="el-icon-edit"></i>编辑</div>
          <div @click.stop="handledialog(item.tier + 1, item, true)" class="popoBox"><i class="el-icon-circle-plus-outline"></i>新建子集</div>
          <div @click.stop="handleAddRule(1, item)" class="popoBox"><img src="../../../assets/img/riLine.png" alt="" />新建规则</div>
          <div @click.stop="handleAddQuestion(3, item)" class="popoBox"><i class="el-icon-delete"></i>删除</div>
          <i slot="reference" class="el-icon-more"></i>
        </el-popover>
      </div>
      <div :style="foldClass(item)" style="overflow: hidden">
        <!-- 评价规则 -->
        <div class="rule" v-if="item.evaluationRuleList && item.evaluationRuleList.length">
          <div class="rule-title">
            评价规则：
            <!-- pc端样式 -->
            <div class="editGrop">
              <i class="el-icon-edit" @click="item.isEditRule = !item.isEditRule"></i>
              <i @click="handleDeleteEvaluation(item.evaluationRuleList)" class="el-icon-delete"></i>
            </div>
            <!-- 移动端样式 -->
            <el-popover popper-class="popoClass" :append-to-body="false" class="dropdownGrop" trigger="click" placement="bottom-end">
              <div class="popoBox" @click.stop="item.isEditRule = !item.isEditRule"><i class="el-icon-edit"></i>编辑</div>
              <div class="popoBox" @click.stop="handleDeleteEvaluation(item.evaluationRuleList)"><i class="el-icon-delete"></i>删除</div>
              <i slot="reference" class="el-icon-more"></i>
            </el-popover>
          </div>
          <!-- 展示规则 -->
          <div class="rule-content">
            <template v-if="!item.isEditRule">
              <div v-for="(rule, todex) in item.evaluationRuleList" :key="todex" class="rule-item">
                <span style="width: 25px">{{ todex + 1 }}、</span> 总分值<span class="blue"> {{ rule.score }}</span> 分：
                <span style="flex: 0.9">{{ rule.name }}</span>
              </div>
            </template>
            <template v-else>
              <div v-for="(rule, todex) in item.evaluationRuleList" :key="todex" class="rule-item">
                <span style="width: 17px">{{ todex + 1 }}、</span> 总分值
                <el-input-number style="width: 40px" size="mini" :controls="false" v-model="rule.score"></el-input-number>分：
                <el-input style="flex: 0.95" type="textarea" :rows="2" placeholder="请输入内容" v-model="rule.name"> </el-input>
                <i @click="handleDeleteEvaluation(item.evaluationRuleList, rule)" class="el-icon-close closeRule"></i>
              </div>
              <div style="text-align: right">
                <el-button @click="handleAddRule(1, item)" type="primary" plain>新增规则</el-button>
                <el-button type="primary" @click="handleAddRule(2, item)">确 定</el-button>
                <el-button @click="$emit('success')">取 消</el-button>
              </div>
            </template>
          </div>
        </div>
        <questItem
          @success="$emit('success')"
          :data-tier="dataTier ? `${dataTier}. ${index + 1}` : `${index + 1}`"
          v-if="item.questionBankList && item.questionBankList.length"
          :data="item.questionBankList"></questItem>
      </div>
    </div>
    <el-dialog @close="dialogClose" :title="`新建${formTiles[form.tier - 1]}`" :visible.sync="dialogFormVisible">
      <el-form :rules="rules" ref="ruleForm" size="small" :model="form" label-position="top">
        <h3 v-if="form.parentName">在「{{ form.parentName }}」下新建</h3>
        <el-form-item prop="name" :label="`${formTiles[form.tier - 1]}名称`">
          <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="form.name"> </el-input>
        </el-form-item>
        <el-form-item :label="`${formTiles[form.tier - 1]}分值`">
          <el-input-number size="small" :controls="false" v-model="form.score"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddQuestion(1)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'questItem',
  components: {},
  data() {
    return {
      questionList: [],
      // 新增模块/指标/题目
      dialogFormVisible: false,
      form: {
        name: '', // 名称
        score: 0, // 分数
        tier: 1, // 层级
        parentId: '', // 父级id
        parentName: '', // 父级名称
        id: '', // 当前 id
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
      },
      formTiles: ['模块', '指标', '指标', '指标', '题目'],
    };
  },
  watch: {
    data: {
      handler(newVal, oldVal) {
        this.questionList = newVal;
      },
      deep: true,
    },
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    dataTier: {
      type: String,
      default: () => '',
    },
  },
  created() {
    this.questionList = this.data;
  },

  mounted() {},
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
  },
  methods: {
    // 触发 弹出框
    handledialog(tier, item, type) {
      console.log('🚀 ~ tier, item, type:', tier, item, type);
      // tier 的意思代表层级
      this.form.tier = tier;
      this.dialogFormVisible = true;
      if (type) {
        // 如果有 type==true，就是新建下一级别
        this.form.parentId = item.id;
        this.form.parentName = item.name;
        return;
      }
      this.form.name = item.name;
      this.form.parentId = item.parentId;
      this.form.id = item.id;
      this.form.score = item.score;
    },
    // 新增 / 编辑 / 删除模块
    handleAddQuestion(type, item) {
      console.log('🚀 ~ this.form:', this.form);
      switch (type) {
        case 1:
          // 新增 / 编辑请求
          this.$refs['ruleForm'].validate((valid) => {
            if (valid) {
              this.httpAddQuestion({ parentId: this.form.parentId, id: this.form.id, name: this.form.name, score: this.form.score, tier: this.form.tier });
            } else {
              console.log('error submit!!');
              return false;
            }
          });
          break;
        case 3:
          // 删除请求
          this.httpDeleteIndustry({ id: item.id });
          break;

        default:
          break;
      }
    },
    httpAddQuestion(parame) {
      this.$axios.post('api/question/addQuestion', parame).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: `${parame.id ? '编辑' : '新增'}成功`,
            type: 'success',
            offset: 80,
          });
          this.$emit('success');
          this.dialogFormVisible = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 80,
          });
        }
      });
    },
    httpDeleteIndustry(parame) {
      this.$confirm('此操作将永久删除该题目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$axios.post('api/question/deleteIndustry', parame).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: `删除成功`,
                type: 'success',
                offset: 80,
              });
              this.$emit('success');
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
                offset: 80,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    dialogClose() {
      this.form = {
        name: '', // 名称
        score: 0, // 分数
        tier: 1, // 层级
        parentId: '', // 父级id
        parentName: '', // 父级名称
        id: '', // 当前 id
      };
    },
    handleIsFold(item) {
      // 只有层级小于 3 的才能够折叠
      if (item.tier < 4) {
        item.isFold = !item.isFold;
      }
    },
    foldClass(item) {
      // 只有层级小于 3 的才能够折叠
      if (item.tier < 4) {
        return item.isFold ? 'height:0px' : 'height:auto';
      }
    },

    /** 规则 和上面新建层级没关系 */
    handleAddRule(type, item) {
      if (type == 1) {
        // score 分数 questionId 父级id
        item.isEditRule = true;
        item.evaluationRuleList.push({ name: '', questionId: item.id, score: 0 });
        return;
      }
      const hasEmptyName = item.evaluationRuleList.some((item) => item.name === '');
      if (hasEmptyName) {
        this.$message({
          message: '请填写评价规则',
          type: 'warning',
          offset: 80,
        });
        return;
      }

      this.$axios.post('api/question/addEvaluation', item.evaluationRuleList).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: `编辑成功`,
            type: 'success',
            offset: 80,
          });
          this.$emit('success');
          item.isEditRule = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 80,
          });
        }
      });
    },
    handleDeleteEvaluation(item, rule) {
      let ids = item.map((e) => e.id).join(',');
      if (rule) {
        ids = rule.id;
      }
      if (!ids) {
        const index = item.indexOf(rule);
        if (index > -1) item.splice(index, 1);
        return;
      }

      this.$confirm('此操作将永久删除该题目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$axios.post('api/question/deleteEvaluation', { id: ids }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: `删除成功`,
                type: 'success',
                offset: 80,
              });
              const index = item.indexOf(rule);
              if (index > -1) item.splice(index, 1);
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
                offset: 80,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
.questions {
  height: 100px;
  box-sizing: border-box;
  height: calc(100% - 84px);
  overflow: auto;
  // background-color: aquamarine;
  .question {
    padding-left: 22px;
    line-height: 28px;
    .question-title {
      position: relative;
      display: flex;
      align-items: center;
      &:hover {
        background-color: #e6f7ff;
        .editGrop {
          display: flex;
        }
      }
    }
    .rule {
      border-radius: 6px;
      margin: 8px 0;
      margin-right: 8px;
      background-color: rgba(80, 88, 105, 0.06);
      border: 1px solid rgba(80, 88, 105, 0.2);
      padding: 8px 10px;
      padding-right: 4px;
      color: rgba(80, 88, 105, 1);
      font-size: 14px;
      display: flex;
      flex-direction: column;
      &:hover {
        .editGrop {
          width: 40px;
          display: flex;
        }
      }
      .rule-title {
        color: rgba(80, 88, 105, 0.6);
        display: flex;
      }
      .rule-content {
        margin-left: 75px;
        .blue {
          font-weight: 600;
        }
        .rule-item {
          display: flex;
          align-items: flex-start;
          letter-spacing: 0.1px;
          margin: 6px 0;
          .closeRule {
            align-self: center;
            font-size: 20px;
            font-weight: 600;
            margin-left: 8px;
          }
        }
      }
    }
  }
}
.editGrop {
  margin-left: auto;
  display: none;
  width: 80px;
  justify-content: space-between;
  align-items: center;
  i {
    cursor: pointer;
    color: rgba(80, 88, 105, 0.5);
  }
}
.dropdownGrop {
  display: none;
  margin-left: auto;
  cursor: pointer;
  font-weight: 600;
  font-size: 20px;
  margin-right: 8px;
}
/deep/ .el-dialog {
  width: 40%;
  border-radius: 10px;
  .el-dialog__header {
    font-weight: 600;
  }
  .el-dialog__body {
    padding: 4px 20px;
    .el-form-item__label {
      padding-bottom: 0;
    }
  }
}
/deep/ .el-input-number.is-without-controls .el-input__inner {
  padding-left: 6px;
  padding-right: 6px;
}
</style>

<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
  .question {
    font-size: 13px;
    line-height: 16px;
    .rule {
      flex-direction: column;
      .rule-title {
        width: 100%;
        margin-bottom: 10px;
      }
      .rule-content {
        margin-left: 0 !important;
      }
    }
  }
  .editGrop {
    display: none !important;
  }
  .dropdownGrop {
    display: block !important;
  }
  /deep/ .el-dialog {
    width: 80%;
  }
}
</style>
<style lang="less">
.popoClass {
  width: 95px;
  min-width: 95px;
  .popoBox {
    display: flex;
    height: 28px;
    align-items: center;
    cursor: pointer;
    i,
    img {
      width: 18px;
      font-size: 16px;
      color: rgba(80, 88, 105, 0.5);
      margin-right: 8px;
    }
  }
}
</style>
